import Card from './Card'
import './fragment'
import { transformData as transformAuthorData } from '../../Avatar'

export default Card

export const transformData = data => {
  return {
    labels: data.categories
      ? data.categories.nodes.map(cat => ({
          label: cat.name,
          url: cat.uri,
        }))
      : null,
    heading: data.title,
    subheading: data.excerpt,
    author: data.author ? transformAuthorData(data.author) : null,
    link: {
      url: data.uri,
    },
  }
}
